import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  margin: 0;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  white-space: nowrap;
`;

export const TooltipTitle = styled.p`
  margin: 0;
`;

export const TooltipItemList = styled.ul`
  padding: 0;
  margin: 0;
`;

export const TooltipItem = styled.li`
  display: block;
  padding-top: 4px;
  padding-bottom: 4px;
  color: ${({ color }) => color || '#000'};
`;



// WEBPACK FOOTER //
// ./src/common/components/charts/tooltip/RechartsToolTipStyles.js